<app-load-nav *ngIf="!isPartner()" [activeMenuItem]="'partner-wallet'"></app-load-nav>

<mat-card class="content-card">
  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxFlex="40">
      <h4>Partner Wallets</h4>
    </div>
    <div fxFlex="60" class="text-right">

      <ng-container *ngIf="isAdmin()">
        <div style="margin-right: 10px; display: inline-block">
          <mat-form-field>
          <mat-select [(ngModel)]="selectedCompanyId">
            <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}</mat-option>
          </mat-select>
          </mat-form-field>
        </div>
      </ng-container>
      <button mat-raised-button color="primary" *ngIf="!isWallet()" [disabled]="isLoading || isBusy || (isAdmin() && !selectedCompanyId) || (!isAdmin() && !isPartner())" (click)="createWallet()">Create new Wallet</button>
    </div>

  </mat-card-header>

  <app-mat-table-generator #table
                           [saveFilters]=true
                           tableName="partnerWalletTable"
                           [useEmbededFilter]="true"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="editEnabled()"
                           [deleteEnabled]="deleteEnabled()"
                           [multiselectEnabled]="false"
                           [customActions]=""
                           [rowClassCallback]="getRowClass"
                           [viewLink]="getViewLink"
                           [editLink]="getEditLink"
                           [defaultSortField] = "'createDate'"
                           [defaultSortDirection]="'desc'"
  >
  </app-mat-table-generator>

</mat-card>

